export default __webpack_public_path__ + "static/media/efw.c644668c.png";